<template>
  <div :class="[level == 1 ? 'my-4' : isOpen ? 'mb-2' : '']">
    <div
      class="grid grid-cols-auto-1 cursor-pointer"
      @click="isOpen = !isOpen"
      :class="[level == 1 ? 'text-xl font-medium tracking-wide' : 'text-base font-medium']"
    >
      <div class="mr-2">
        <icon name="ArrowRight" :settings="{active: isOpen}" />
      </div>
      <div class="mb-2">{{ title }}</div>
    </div>
    <div class="ml-3 text-sm" v-if="isOpen">
      <slot class="stack-lg"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoSection",
  data() {
    return {
      isOpen: false
    };
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    level: {
      type: String,
      default: "1"
    }
  },
  components: {},
  methods: {},
  computed: {},
  created() {}
};
</script>